// extracted by mini-css-extract-plugin
export default {"eigengrau":"#101828","label":"styles_label__xDqmI"};